/**
 * Blog search bar with live article suggestions (main-blog section).
 * Ported from the old theme's inline script; suggestions are built with DOM
 * APIs instead of innerHTML.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var searchInput = document.getElementById('blog-quick-search');
    var results = document.getElementById('blog-search-results');
    if (!searchInput || !results) return;

    function hide() {
      results.hidden = true;
    }

    function render(articles) {
      results.textContent = '';
      if (!articles.length) {
        hide();
        return;
      }
      articles.forEach(function (article) {
        var link = document.createElement('a');
        link.href = article.url;
        link.className = 'blog-suggestion-link';
        var item = document.createElement('div');
        item.className = 'blog-suggestion-item';
        if (article.image) {
          var img = document.createElement('img');
          img.src = article.image;
          img.alt = '';
          img.className = 'suggestion-image';
          img.width = 50;
          img.height = 50;
          item.appendChild(img);
        }
        item.appendChild(document.createTextNode(article.title));
        link.appendChild(item);
        results.appendChild(link);
      });
      results.hidden = false;
    }

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      if (query.length < 3) {
        hide();
        return;
      }
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=article')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render((data.resources && data.resources.results.articles) || []);
        })
        .catch(function () { hide(); });
    });

    document.addEventListener('click', function (event) {
      if (!searchInput.contains(event.target)) hide();
    });
  });
})();
